
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import db from "../db";
import service from "../services/lingua/Pacchettoservice";

function LangRequest({ pacchetto, ...props }) {


    const pacchetti = useLiveQuery(() => db.pacchetti.where({ nome: pacchetto }).toArray());

    const langs = useLiveQuery(() => db.lingue.toArray());

    //qui lang deve esistere (ci pensa la bar a impostarla)
    if (pacchetti === undefined || langs === undefined || langs.length === 0) {
        return null;
    }
    const pacchetto0 = pacchetti.length === 0 ? null : pacchetti[0];

    console.log(pacchetto0?.versione);
    return (
        <LangRequest0
            fuVersione={pacchetto0?.versione}
            pacchettoNome={pacchetto}
            lingua={langs[0]}
            pacchetto={pacchetto0}
            {...props}
        />
    );

}

function LangRequest0({ pacchetto, pacchettoNome, lingua, children }) {

    const [ok, setOk] = useState(false);

    const save = async (rData) => {
        //memorizza pacchetto
        const dataLettura = new Date();
        const { traduzioni, id, ...data } = { ...rData };
        if (pacchetto) {
            await db.pacchetti.update(pacchetto.id, { ...data, dataLettura, });
        } else {
            await db.pacchetti.add({ ...data, id, dataLettura });
        }
        //memorizza traduzioni
        const codice = lingua.codice;
        const field = 'lingua' + codice.charAt(0).toUpperCase() + codice.slice(1);
        for (let i in traduzioni) {
            const item = traduzioni[i];
            const valore = item[field];
            const exists = await db.traduzioni.where({ pacchettoId: item.pacchettoId, chiave: item.chiave }).first()
            if (exists) {
                await db.traduzioni.update(exists.id, { valore });
            } else {
                await db.traduzioni.add({ pacchettoId: item.pacchettoId, chiave: item.chiave, valore });
            }
        }
        setOk(true);
    }


    useEffect(() => {
        const limit = 15 * 60 * 1000;
        if (!pacchetto || (new Date() - pacchetto.dataLettura > limit)) {
            console.log('langRequest richiedo pacchetto ' + pacchettoNome);
            service.search({ nome: pacchettoNome, expand: 'traduzioni', }).then((response) => {
                if (response.data.length !== 0) {
                    save(response.data[0]);
                }
            })
        } else if (pacchetto) {
            setOk(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pacchetto, pacchettoNome]);

    return ok ? children : null;
}

export default LangRequest;